<template>
  <div class="private-message">
    <el-dialog :title="titleType" :visible.sync="privateDialogVisible" width="35%" @close="update">
      <el-form ref="form" :model="form" label-width>
        <el-form-item label>
           <el-select class="input-v"
              v-model="form.id"
              filterable
              clearable
              @change="seachStatus"
              placeholder="请选择发送人昵称"
              style="width:100%">
                <el-option
                  v-for="(i,index) in roleOptions"
                  :key="index"
                  :label="i.name"
                  :value="i.id"
                ></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="form.message"
            placeholder="请输入消息内容"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <p>选择链接类型及链接（可不添加）</p>
          <div class="seach-list">
            <el-select
              class="input-v l"
              v-model="search.type"
              clearable
              placeholder="请选择类型"
              @change="getType"
            >
              <el-option
                v-for="(item,index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="search.original_links"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              placeholder="搜索课程或者是专题的名字"
              class="input-sea"
              @change="getValue"
            >
              <el-option
                v-for="(item,index) in linkOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer tc">
        <el-button @click="privateDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendMessage(messageType)" :disabled="!(form.id&&form.message)">发 送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { _allCourseList, _allTopicList } from "@/api/section-links.js";
import { _replyMessage } from "@/api/user-message.js";
//引入角色列表
import { _adminIndex } from "@/api/admin.js";

import qs from "qs";
import { constants } from 'crypto';

//初始化信息
const FORM_INFO=function(){
  return{
     message: "",
     link_name: "",
     id:''
  }
}
const SEARCH_INFO=function(){
  return{
      original_links: "",//跳转的数据
      type:1,//跳转链接的类型
      page: 1,
      size: 10,
  }
}

export default {
  created() {
    this.initCouresList();
    this.initTopicList();
    //加载用户列表
    this.adminIndex();
  },
  props: {
    privateVisible: {
      type: Boolean,
      default: false
    },
    private_info: {
      type: Object,
      default: {}
    },
    messageType: {
      type: String
    },
    isEdit:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    privateVisible(val) {
      this.privateDialogVisible = val;
    },
    private_info(val) {
      // console.log(val);
      //编辑的时候获取数据
      if(this.isEdit&&(Object.keys(this.private_info).length>0)){
        this.form.message=val.msg_content;
        // console.log(this.roleOptions);
        let data=this.roleOptions.find(item=>{
          if(val.send_user_name==item.name){
            return item.id;
          }
        })
        this.form.id=data.id;
        if(val.linkType==3){
          this.search.type=""
        }else{
          this.search.type=val.linkType;
          this.search.original_links=val.original_links;
        }
      }
    },
  },
  computed: {
    //用户列表的私人消息，和用户的消息列表的全员消息和私人列表的的区分
    titleType() {
      if (this.messageType == 1) {
        return "私人消息";
      } else if (this.messageType == 2) {
          return "全员消息";
      }
    },
     //获取用户的头像和昵称
  },
  data() {
    return {
      privateDialogVisible: false,
      form:FORM_INFO(),
      search: {
        original_links: "",//跳转的数据
        type:1,//跳转链接的类型
        page: 1,
        size: 10,
      },
      linkOptions: [],
      options: [
        {
          value: 1,
          label: "课程"
        },
        {
          value: 2,
          label: "专题"
        }
      ],
      roleOptions:[]
    };
  },
  methods: {
    //远程实时搜索
    remoteMethod(query){
       if (this.search.type== 1) {
        this.initCouresList(query);
      } else if (this.search.type == 2) {
        this.initTopicList(query);
      } else {
        this.linkOptions = [];
      }
    },
    //点击搜索
    seachList() {},
    handleChange(val) {
      console.log(val);
    },
    seachStatus(val){
      console.log(val);
    },
    // 获取发送人的头像和昵称
    getUserInfo() {
      let data = this.roleOptions.find(item => {
        if ((this.form.id == item.id)) {
          return item;
        }
      });
      return data;
    },
    update() {
      this.search=SEARCH_INFO();
      this.form=FORM_INFO();
      this.$emit("update:privateVisible", false);
    },
    getType(val) {
      this.search.original_links='';
      if (val == 1) {
        this.initCouresList();
      } else if (val == 2) {
        this.initTopicList();
      } else {
        this.linkOptions = [];
      }
    },
    getValue(val){
      console.log(val);
    },
    //加载课程的列表
    initCouresList(query) {
      query?query:query=""
      _allCourseList({
        params: {
          link_mode: 1,
          keywords:query
        }
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.linkOptions = data.map(item => {
            return {
              label: item.course_name,
              value: item.link,
            };
          });
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    initTopicList(query) {
      query?query:query=""
      _allTopicList({
        params: {
          link_mode: 1,
          keywords:query
        }
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.linkOptions = data.map(item => {
            return {
              label: item.topic_name,
              value: item.link,
            };
          });
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    //加载员工列表
    adminIndex() {
      _adminIndex({
        params: {
          role_id:1 
        }
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          let data = res.result.list;
          this.roleOptions = data.map(item => {
            return {
              name: item.name,
              id: item.id,
              head_img:item.head_img
            };
          });
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //发送消息
    sendMessage(type){
      let data={
          user_id:this.private_info.user_id,
          send_user_name:this.getUserInfo().name,
          msg_content:this.form.message,
          original_links:this.search.original_links,
          pfrofile_photo:this.getUserInfo().head_img,
          type:type,
          id:''
      }
      if(this.isEdit){
        data.id=this.private_info.system_msg_id
      }
      _replyMessage({
        data:qs.stringify(data)
      })
      .then(res=>{
        console.log(res);
         if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.$emit('uploadStatus',true);
        } else {
          this.$message.error(res.errorMsg);
        }
      })
      this.privateDialogVisible=false;
    }
  }
};
</script>


<style lang="less" scoped>
.seach-list {
  display: flex;
  .input-v {
    flex: 0.8;
  }
  .input-sea {
    flex: 1.1;
    margin-left: 30px;
  }
}
</style>
